import React, { Dispatch, SetStateAction, useState } from 'react';

type FunctionsType = {
  listCampaigns?: (key: string) => void;
  listArchived?: () => void;
  getCampaign?: () => void;
};

type CampaignsState = {
  refetchFunctions: Record<string, Function>;
  setRefetchFunctions: Dispatch<SetStateAction<FunctionsType>>;
};

const CampaignsContext = React.createContext<Partial<CampaignsState>>({});

interface ProviderProps {
  children: React.ReactNode;
}

const CampaignsProvider: React.FC<ProviderProps> = ({ children }) => {
  const [refetchFunctions, setRefetchFunctions] = useState<FunctionsType>({
    listCampaigns: (key: string) => {},
    listArchived: () => {},
    getCampaign: () => {},
  });

  return (
    <CampaignsContext.Provider value={{ refetchFunctions, setRefetchFunctions }}>
      {children}
    </CampaignsContext.Provider>
  );
};

function useCampaignsState() {
  const context = React.useContext(CampaignsContext);
  if (context === undefined) {
    throw new Error('useCampaignsState must be used within a CampaignsProvider');
  }
  return context;
}

export { CampaignsProvider, useCampaignsState };
